<!-- 登录 -->
<template>
  <div class="login-wrap">
    <div class="login">
      <img src="../../assets/img/loginimg.png" />
      <div class="login-left">
        <h2>欢迎来到  海量数据学院</h2>
        <p>专研使你出类拔萃，学习让你与众不同</p>
      </div>
      <div class="login-right">
          <img class="logo" src="../../assets/img/logo.png" />
          <div class="option">
            <p :class="type==1?'cur':''" @click="onCur(1,'ruleForm')">验证码登录</p>
            <p :class="type==2?'cur':''" @click="onCur(2,'ruleForm')">密码登录</p>
          </div>
          <div class="e-form">
            <!-- 密码登录 -->
            <el-form v-if="type==2" label-position="top" :model="ruleForm1" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="账号" prop="mobile">
                <el-input v-model="ruleForm1.mobile" autocomplete="off" placeholder="请输入手机/邮箱"></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="pwd">
                <el-input type="password" v-model="ruleForm1.pwd" placeholder="请输入密码"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button style="background-color: #ff821c" size="small" type="warning" :loading="loading" @click="submitForm('ruleForm')">登录</el-button>
              </el-form-item>
            </el-form>

            <!-- 验证码登录 -->
            <el-form v-else label-position="top" :model="ruleForm2" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="账号" prop="mobile">
                <el-input v-model="ruleForm2.mobile" autocomplete="off" placeholder="请输入手机/邮箱"></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="code" class="code">
                <el-input v-model="ruleForm2.code" placeholder="请输入验证码" maxlength="6"></el-input>
                <el-button style="background-color: #ff821c" size="small" type="warning" :loading="loadingl" @click="submitCode" :disabled="countdown > 0"> {{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}</el-button>
              </el-form-item>
              <el-form-item class="btttom">
                <el-button style="background-color: #ff821c" size="small" type="warning" :loading="loading" @click="submitForm('ruleForm')">登录</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="tip">
            <p style="cursor: pointer;" @click="submitRegister">注册新用户</p>
            <p>已有用户名，<span @click="submitForget">忘记密码？</span></p>
          </div>
      </div>
    </div>
  </div>
    
</template>
<script type="text/ecmascript-6">
import { apiLogin,getPhoneCheckCode,getEmail} from '../../api/userMG'
import md5 from 'js-md5';
export default {
  name: 'login',
  data() {
    const phone = /^1[3-9]\d{9}$/;
    const email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    var valid = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机/邮箱'));
      } 
      // else if(!phone.test(value) || !email.test(value)){
      //   callback(new Error('手机/邮箱格式错误'));
      // }
      else{
        callback();
      }
    };
    var valpass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      }else {
        callback();
      }
    };
    var valcode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'));
      }else {
        callback();
      }
    };
    return {
      type:2,
      ruleForm1:{
        mobile:'',
        pwd:''
      },
      ruleForm2:{
        mobile:'',
        code:''
      },
      rules: {
        mobile: [
          { validator: valid, trigger: 'blur' }
        ],
        pwd: [
          { validator: valpass, trigger: 'blur' }
        ],
        code: [
          { validator: valcode, trigger: 'blur' }
        ]
      },
      loading:false,
      countdown: 0, // 倒计时秒数
      intervalId: null, // 存储interval的id
      loadingl:false
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    
  },
  // 里面的函数只有调用才会执行
  methods: {
    onCur(e,formName){
      this.type = e
      this.$refs[formName].resetFields();
    },
    submitCode(){
      if(!this.ruleForm2.mobile){
        this.$message({
          message: '请输入手机/邮箱',
          type: 'warning'
        });
        return
      }
      const value = this.ruleForm2.mobile.trim();
      let account;
      let params;
      if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
        account = getEmail;
        params = {
          email:this.ruleForm2.mobile
        }
      } else if (/^1\d{10}$/.test(value)) {
        let sign = md5(this.ruleForm2.mobile+'ZHE_GE_JIE_KOU_YI_JIN_JIA_MI_LE')
        account = getPhoneCheckCode;
        params = {
          phoneNum:this.ruleForm2.mobile,
          sign:sign
        }
      }
      this.loadingl = true;
      account(params).then(res => {
        console.log('验证码',res);
        this.loadingl = false;
        if(res.code==0){
          this.startCountdown(60);
        }
      })
      .catch(err => {
        this.loading = false
      })
    },
    startCountdown(seconds) {
      this.countdown = seconds;
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1;
        } else {
          clearInterval(this.intervalId);
        }
      }, 1000);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          let ruleForm;
          if(this.type==1){
            ruleForm = this.ruleForm2
          }else{
            ruleForm = this.ruleForm1
          }
          apiLogin(ruleForm).then(res => {
            console.log('登录',res);
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('username', res.data.username);
            localStorage.setItem('headPic', res.data.headPic);
            localStorage.setItem('id', res.data.userNo);
            sessionStorage.setItem('keyPath', 0);
            this.loading = false
            this.$router.push({path:'/'})
          })
          .catch(err => {
            this.loading = false
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 去注册
    submitRegister(){
      this.$router.push({path:'/login/register'})
    },
    // 忘记密码
    submitForget(){
      this.$router.push({path:'/login/forget'})
    }
  }
}
</script>

<style scoped>
  @media (min-width: 1366px) {
    .login { 
        width: 1000px;
      }
    }
  @media (min-width: 1600px) {
    .login {
      width: 1300px;
    }
  }
.login-wrap{
  width: 100%;
  background-image: url('../../assets/img/loginback.jpg');
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 100%;
}
.login{
  position: relative;
  box-shadow: 0px 0px 100px 0px rgba(0,0,0,0.1);
}
.login img{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.login-left{
  position: absolute;
  top: 50px;
  left: 50px;
}
.login-left h2{
  margin:0 auto 15px;
  color: black;
}
.login-left p{
  color: #303443;
  font-size: 13px;
}
.login-right{
  position: absolute;
  top: 50%;
  right: 100px;
  transform: translate(0,-50%);
  width: 300px;
}
.login-right .logo{
  width: 170px;
  margin: 0 auto 20px;
}
/* .option{
  display: flex;
  align-items: center;
  justify-content: center;
} */
.option {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}
.option p{
  width: 50%;
  text-align: center;
  font-size: 13px;
  border-bottom: 3px solid #efefef;
  padding-bottom: 12px;
  cursor: pointer;
}
.option .cur{
  border-bottom: 3px solid #ff821c;
}
.e-form .key{
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
}
.e-form .prop{
  color: #ff821c;
  margin-right: 2px;
}
.e-form /deep/ .el-form--label-top .el-form-item__label{
  padding: 0 !important;
} 
.e-form /deep/ .el-button--small{
  width: 100%;
  padding: 12px 0;
}
.code /deep/ .el-button--small{
  width: auto;
  padding: 12px 20px;
}
.tip{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tip p{
  font-size: 11px;
  color: #999999;
}
.tip p span{
  font-size: 11px;
  color: #ff821c;
  cursor: pointer;
}
.code /deep/ .el-form-item__content{
  display: flex;
}
.btttom{
  margin-top: 20px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/login/login.vue